import HomeIcon from "@material-ui/icons/Home";
import PeopleIcon from "@material-ui/icons/People";
import WarningIcon from "@material-ui/icons/Warning";
import PieChartIcon from "@material-ui/icons/PieChart";
import FormatListNumbered from "@material-ui/icons/FormatListNumbered";
import { Role, Route } from "api";
import {
    IconCar,
    IconCarCrash,
    IconGavel,
    IconIndustry,
    IconRoad,
    IconTrophy,
} from "ui/componentes/Icons";
import {
    Admin,
    BrandsView,
    BroadcastMessages,
    CarsView,
    ChampionshipForm,
    Championships,
    ChampionshipStandings,
    ForgetPassword,
    Home,
    IncidentsReportView,
    InfractionForm,
    PageNotFound,
    PasswordReset,
    PointsByRaceForm,
    PointsByRaceView,
    Profile,
    ProtestView,
    RaceControlAfterRaceView,
    RaceControlView,
    RoundEdit,
    Seasons,
    SignIn,
    SignUp,
    TracksView,
    Users,
} from "ui/views";
import { InfractionList } from "ui/views/InfractionViews/InfractionList";
import { Settings } from "@material-ui/icons";

export const Routes: Route[] = [
    //AUTH
    {
        id: "sign_in",
        route: "/sign-in",
        component: SignIn,
    },
    {
        id: "sign_up",
        route: "/sign-up",
        component: SignUp,
    },
    {
        id: "auth_reset_methods",
        route: "/auth/resetMethods",
        component: PasswordReset,
    },
    {
        id: "forget_password",
        route: "/auth/forgetPassword",
        component: ForgetPassword,
    },
    {
        id: "page_not_found",
        route: "/page-not-found",
        component: PageNotFound,
    },
    {
        id: "root",
        route: "/",
        component: Home,
        menuIcon: HomeIcon,
        label: "Início",
        showInMenu: true,
    },
    // {
    //     id: "schedule",
    //     route: "/schedule",
    //     component: ScheduleView,
    //     label: "Calendário",
    //     menuIcon: IconSchedule,
    //     showInMenu: true,
    //     privateRoute: true,
    //     roles: [Role.ADMIN, Role.COMISSARY, Role.DRIVER],
    // },
    //CHAMPIONSHIP ROUTES
    {
        id: "seasons",
        route: "/seasons",
        label: "Temporadas",
        component: Seasons,
        menuIcon: PieChartIcon,
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "championships",
        route: "/championships",
        label: "Campeonatos",
        menuIcon: IconTrophy,
        component: Championships,
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "championship",
        route: "/championship",
        component: ChampionshipForm,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "championship",
        route: "/championship/:id",
        component: ChampionshipForm,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "standings",
        route: "/championship/standings/:championshipId",
        component: ChampionshipStandings,
    },
    {
        id: "raceControl",
        route: "/race_control/:id/:afterRace",
        component: RoundEdit,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY],
    },
    {
        id: "raceControlView",
        route: "/race_control_list",
        label: "Moderações",
        menuIcon: IconCarCrash,
        component: RaceControlView,
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY],
    },
    {
        id: "raceControlAfterRaceView",
        route: "/race_control_after_race_list",
        label: "Análises pós corrida",
        menuIcon: IconCarCrash,
        component: RaceControlAfterRaceView,
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY],
    },
    {
        id: "broadcastMessages",
        route: "/broadcast_messages/:roundId",
        component: BroadcastMessages,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY],
    },
    {
        id: "incidentsReport",
        route: "/incidents_report/:championshipId",
        component: IncidentsReportView,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY, Role.DRIVER],
    },
    //USERS ROUTES
    {
        id: "users",
        route: "/users",
        label: "Usuários",
        menuIcon: PeopleIcon,
        component: Users,
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "profile",
        route: "/profile",
        component: Profile,
        privateRoute: true,
    },
    {
        id: "profile",
        route: "/profile/:id",
        component: Profile,
        privateRoute: true,
        roles: [Role.ADMIN],
    },

    //INFRACTIONS
    {
        id: "infractions",
        route: "/infractions",
        component: InfractionList,
        menuIcon: WarningIcon,
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
        label: "Infrações",
    },
    {
        id: "infraction",
        route: "/infraction/:id",
        component: InfractionForm,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "infraction",
        route: "/infraction",
        component: InfractionForm,
        privateRoute: true,
        roles: [Role.ADMIN],
    },

    //PROTESTS
    {
        id: "protests",
        route: "/protest/:id",
        component: ProtestView,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY, Role.DRIVER],
    },
    {
        id: "protests",
        route: "/protest",
        component: ProtestView,
        menuIcon: IconGavel,
        label: "Meus protestos",
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN, Role.COMISSARY, Role.DRIVER],
    },

    //BRANDS
    {
        id: "brands",
        route: "/brands",
        component: BrandsView,
        menuIcon: IconIndustry,
        label: "Marcas",
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },

    //CARS
    {
        id: "cars",
        route: "/cars",
        component: CarsView,
        menuIcon: IconCar,
        label: "Carros",
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },

    //TRACKS
    {
        id: "tracks",
        route: "/tracks",
        component: TracksView,
        menuIcon: IconRoad,
        label: "Pistas",
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },

    //POINTS BY RACE CONFIGURATION
    {
        id: "pointsByRaceConfig",
        route: "/points-by-race-configs",
        component: PointsByRaceView,
        menuIcon: FormatListNumbered,
        label: "Pontos por Corrida",
        showInMenu: true,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "pointsByRaceConfigForm",
        route: "/points-by-race-config",
        component: PointsByRaceForm,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    {
        id: "pointsByRaceConfigForm",
        route: "/points-by-race-config/:id",
        component: PointsByRaceForm,
        privateRoute: true,
        roles: [Role.ADMIN],
    },
    //ADMIN
    {
        id: "admin",
        route: "/admin",
        component: Admin,
        menuIcon: Settings,
        label: "Admin",
        showInMenu: true,
        roles: [Role.ADMIN],
    },
];
